/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Content_Feature_1_BodyInputs */

const en_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laser-measured yardage markers, fairway cuts, and built-up greens with flags. Practice with accurate distances and realistic landing areas.`)
};

const es_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores de distancia medidos con láser, calles segadas y greens elevados con banderas. Practica con distancias precisas y zonas de aterrizaje realistas.`)
};

const de_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per Laser vermessene Entfernungsmarker, gemähte Fairways und erhöhte Grüns mit Fahnen. Üben Sie mit genauen Distanzen und realistischen Landezonen.`)
};

const zh_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激光测距的码数标识、修剪整齐的球道以及插有旗杆的抬高果岭。用准确的距离和逼真的落点区域进行练习。`)
};

const ar_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`علامات مسافة مقيسة بالليزر وممرات فيرواي مشذّبة وملاعب خضراء مرتفعة مع أعلام. تدرّب بمسافات دقيقة ومناطق هبوط واقعية.`)
};

const fr_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repères de distance mesurés au laser, fairways tondus et greens surélevés avec drapeaux. Entraînez-vous avec des distances précises et des zones de réception réalistes.`)
};

const vi_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mốc khoảng cách đo bằng laser, fairway được cắt tỉa và green nâng cao có cờ. Tập luyện với khoảng cách chính xác và vùng bóng rơi chân thực.`)
};

const sw_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alama za umbali zilizopimwa kwa leza, fairway zilizokatwa na grini zilizoinuliwa zenye bendera. Fanya mazoezi kwa umbali sahihi na maeneo halisi ya mpira kutua.`)
};

const th_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ป้ายบอกระยะที่วัดด้วยเลเซอร์ แฟร์เวย์ที่ตัดแต่งแล้ว และกรีนยกสูงพร้อมธง ซ้อมด้วยระยะที่แม่นยำและจุดตกของลูกที่สมจริง`)
};

const bs_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laserski izmjerene oznake udaljenosti, pokošeni fairwayi i uzdignuti greenovi sa zastavicama. Vježbajte s preciznim udaljenostima i realnim zonama pada loptice.`)
};

const ja_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レーザーで計測した距離表示、刈り込まれたフェアウェイ、旗の立った盛り上がったグリーン。正確な距離とリアルな落としどころで練習できます。`)
};

const ko_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레이저로 측정한 거리 표지, 잘 깎은 페어웨이, 깃발이 꽂힌 돋운 그린. 정확한 거리와 실제와 같은 낙구 지점으로 연습하세요.`)
};

const pt_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores de distância medidos a laser, fairways aparados e greens elevados com bandeiras. Treine com distâncias precisas e áreas de queda realistas.`)
};

const it_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segnalatori di distanza misurati al laser, fairway rasati e green rialzati con bandiere. Allenati con distanze precise e zone di atterraggio realistiche.`)
};

const sv_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lasermätta avståndsmarkeringar, klippta fairways och upphöjda greener med flaggor. Träna med exakta avstånd och realistiska landningsområden.`)
};

const nl_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Met laser bepaalde afstandsmarkeringen, gemaaide fairways en verhoogde greens met vlaggen. Oefen met nauwkeurige afstanden en realistische landingszones.`)
};

const da_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lasermålte afstandsmarkører, klippede fairways og opbyggede greens med flag. Træn med præcise afstande og realistiske landingsområder.`)
};

const nb_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lasermålte avstandsmarkører, klipte fairwayer og oppbygde greener med flagg. Tren med nøyaktige avstander og realistiske landingsområder.`)
};

const fi_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laserilla mitatut etäisyysmerkit, leikatut väylät ja korotetut lipulliset viheriöt. Harjoittele tarkoilla etäisyyksillä ja realistisilla laskeutumisalueilla.`)
};

const pl_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znaczniki odległości wyznaczone laserowo, koszone fairwaye i podwyższone greeny z flagami. Trenuj z dokładnymi odległościami i realistycznymi strefami lądowania piłki.`)
};

const ru_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отметки дистанции, измеренные лазером, подстриженные фервеи и приподнятые грины с флажками. Тренируйтесь с точными дистанциями и реалистичными зонами приземления.`)
};

const tr_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lazerle ölçülmüş mesafe işaretleri, biçilmiş fairwayler ve bayraklı yükseltilmiş greenler. Doğru mesafeler ve gerçekçi iniş alanlarıyla antrenman yapın.`)
};

const hi_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लेज़र से मापे गए दूरी मार्कर, कटे हुए फ़ेयरवे और झंडों वाले ऊँचे ग्रीन। सटीक दूरियों और वास्तविक लैंडिंग क्षेत्रों के साथ अभ्यास करें।`)
};

const id_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penanda jarak yang diukur dengan laser, fairway yang dipangkas, dan green yang ditinggikan lengkap dengan bendera. Berlatihlah dengan jarak akurat dan area pendaratan yang realistis.`)
};

const ms_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penanda jarak yang diukur dengan laser, fairway yang dipotong rapi dan green yang ditinggikan dengan bendera. Berlatih dengan jarak yang tepat dan kawasan pendaratan yang realistik.`)
};

const cs_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laserem změřené ukazatele vzdálenosti, sečené fairwaye a vyvýšené greeny s praporky. Trénujte s přesnými vzdálenostmi a realistickými místy dopadu.`)
};

const el_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δείκτες απόστασης μετρημένοι με λέιζερ, κουρεμένα φέργουεϊ και υπερυψωμένα γκριν με σημαίες. Προπονηθείτε με ακριβείς αποστάσεις και ρεαλιστικές ζώνες προσγείωσης.`)
};

const he_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סמני מרחק שנמדדו בלייזר, פיירוויים מכוסחים וגרינים מוגבהים עם דגלים. התאמנו עם מרחקים מדויקים ואזורי נחיתה מציאותיים.`)
};

const af_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afstandmerkers wat met 'n laser gemeet is, gesnyde fairways en opgeboude greens met vlae. Oefen met akkurate afstande en realistiese landingsareas.`)
};

const hu_range_content_feature_1_body = /** @type {(inputs: Range_Content_Feature_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lézerrel bemért távolságjelzők, nyírt fairwayek és zászlós, kiemelt greenek. Gyakorolj pontos távolságokkal és valósághű landolási zónákkal.`)
};

/**
* | output |
* | --- |
* | "Laser-measured yardage markers, fairway cuts, and built-up greens with flags. Practice with accurate distances and realistic landing areas." |
*
* @param {Range_Content_Feature_1_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_content_feature_1_body = /** @type {((inputs?: Range_Content_Feature_1_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Content_Feature_1_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_content_feature_1_body(inputs)
	if (locale === "de") return de_range_content_feature_1_body(inputs)
	if (locale === "zh") return zh_range_content_feature_1_body(inputs)
	if (locale === "ar") return ar_range_content_feature_1_body(inputs)
	if (locale === "fr") return fr_range_content_feature_1_body(inputs)
	if (locale === "vi") return vi_range_content_feature_1_body(inputs)
	if (locale === "sw") return sw_range_content_feature_1_body(inputs)
	if (locale === "th") return th_range_content_feature_1_body(inputs)
	if (locale === "bs") return bs_range_content_feature_1_body(inputs)
	if (locale === "ja") return ja_range_content_feature_1_body(inputs)
	if (locale === "ko") return ko_range_content_feature_1_body(inputs)
	if (locale === "pt") return pt_range_content_feature_1_body(inputs)
	if (locale === "it") return it_range_content_feature_1_body(inputs)
	if (locale === "sv") return sv_range_content_feature_1_body(inputs)
	if (locale === "nl") return nl_range_content_feature_1_body(inputs)
	if (locale === "da") return da_range_content_feature_1_body(inputs)
	if (locale === "nb") return nb_range_content_feature_1_body(inputs)
	if (locale === "fi") return fi_range_content_feature_1_body(inputs)
	if (locale === "pl") return pl_range_content_feature_1_body(inputs)
	if (locale === "ru") return ru_range_content_feature_1_body(inputs)
	if (locale === "tr") return tr_range_content_feature_1_body(inputs)
	if (locale === "hi") return hi_range_content_feature_1_body(inputs)
	if (locale === "id") return id_range_content_feature_1_body(inputs)
	if (locale === "ms") return ms_range_content_feature_1_body(inputs)
	if (locale === "cs") return cs_range_content_feature_1_body(inputs)
	if (locale === "el") return el_range_content_feature_1_body(inputs)
	if (locale === "he") return he_range_content_feature_1_body(inputs)
	if (locale === "af") return af_range_content_feature_1_body(inputs)
	if (locale === "hu") return hu_range_content_feature_1_body(inputs)
	return en_range_content_feature_1_body(inputs)
});